// advertisementContainer
import React, { useState, useRef, useEffect } from "react";
import { header, people } from "../../config/imagesLink";
import Select from "react-select";
import axios, { productionWork } from "../../API/axios";
import { debounce } from "lodash";
import TranslateIcon from '@mui/icons-material/Translate';
import { Button, Dropdown } from "react-bootstrap";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Toggle from "../../Toggle";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LeftNavigation from "./LeftNavigation";
import CreateCompany from "../CreateCompany/CreateCompany";
import TopNotification from "./TopNotification";
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import PersonOutlineSharpIcon from '@mui/icons-material/PersonOutlineSharp';
import SettingsSharpIcon from '@mui/icons-material/SettingsSharp';
import AdminPanelSettingsSharpIcon from '@mui/icons-material/AdminPanelSettingsSharp';
import PowerSettingsNewSharpIcon from '@mui/icons-material/PowerSettingsNewSharp';
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import MenuSharpIcon from '@mui/icons-material/MenuSharp';
import base58 from "base-58";
import { Buffer } from "buffer";
import TopMessage from "./TopMessage";
import moment from "moment";
import useChatStore from "../OuterChatBox/useChatStore";
import useWindowSize from "../useWindowSize";
import { isMobileViewportWidth } from "../../config/breakpoints";
import CheckIcon from "@mui/icons-material/Check";
import { Tooltip } from "@mui/material";
import { ShimmerTitle } from "react-shimmer-effects";
import { ShimmerDiv } from "@skeleton";
import { ADMIN_APP_ORIGIN, joinUrl } from "../../config/appConfig";
import { disconnectRealtimeHub } from "../../Services/apiService";
import i18n from "../../i18n";
import { t } from "i18next";
import { mapGlobalSearchList } from "../../utility/globalSearchMap";
import {
  getStoredLangCode,
  normalizeLangCode,
  setStoredLangCode,
  SUPPORTED_LANG_CODES,
} from "../../utils/language";
import { toggleAppTheme } from "../../utils/theme";
import useThemeStore from "../../store/useThemeStore";
const suggestions = [
  "Apple",
  "Banana",
  "Cherry",
  "Date",
  "Elderberry",
  "Fig",
  "Grape",
  "Honeydew",
  "Kiwi",
  "Lemon",
];
const Header = ({ notifiCount, setNotifiCount, msgCount, setMsgCount, NotificationCount, MessagesCount, mobileHeaderPanel, setMobileHeaderPanel }) => {
  const guestModeData = localStorage.getItem("guestMode");
  const sessionId = localStorage.getItem("sessionId");
  const language = getStoredLangCode();
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");
  const userUid = localStorage.getItem("userUid");
  const [isOpen, setIsOpen] = useState(false);
  const size = useWindowSize();
  const isMobile = isMobileViewportWidth(size.width);
  const [currentLang, setCurrentLang] = useState(
    normalizeLangCode(i18n?.language || language || "en")
  );


  const { clearAllChats } = useChatStore();

  const toggleMenu = () => {
    setIsOpen((prevState) => !prevState);
    console.log("Menu is toggling...");
  };

  useEffect(() => {
    if (!isOpen) return undefined;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen]);

  useEffect(() => {
    const updateHeaderHeight = () => {
      const visibleHeader = Array.from(
        document.querySelectorAll(".mainheader")
      ).find((el) => window.getComputedStyle(el).display !== "none");
      const height = visibleHeader ? Math.round(visibleHeader.getBoundingClientRect().height) : 60;
      document.documentElement.style.setProperty("--wlj-header-height", `${height}px`);
    };

    updateHeaderHeight();
    window.addEventListener("resize", updateHeaderHeight);

    const observer = new ResizeObserver(updateHeaderHeight);
    document.querySelectorAll(".mainheader").forEach((el) => observer.observe(el));

    return () => {
      window.removeEventListener("resize", updateHeaderHeight);
      observer.disconnect();
    };
  }, []);

  const [showSub, setShowSub] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownRes, setShowDropdownRes] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  const toggleDropdownRes = () => {
    setShowDropdownRes(!showDropdownRes);
  };
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  //************************Search Start  ************************//
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [inputValue, setInputValue] = useState("");
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
  };
  const [options, setOptions] = useState([]);
  const [searchUser, setSearchUser] = useState([]);
  const [searchHashtag, setSearchHashtag] = useState([]);
  const [searchComp, setSearchComp] = useState([]);
  const [searchJob, setSearchJob] = useState([]);
  const [searchPost, setSearchPost] = useState([]);
  const [searchBlog, setSearchBlog] = useState([]);
  const [searchArticle, setSearchArticle] = useState([]);

  const clearSearchDropdown = () => {
    setOptions([]);
    setInputValue("");
    setSearchUser([]);
    setSearchHashtag([]);
    setSearchComp([]);
    setSearchJob([]);
    setSearchPost([]);
    setSearchBlog([]);
    setSearchArticle([]);
  };

  const addOptions = () => {
    setIsLoading(true);
    const data = {
      deviceType: "Web",
      pageNumber: page,
      pageSize: 30,
    };
    axios
      .post(`SMFeatures/GlobalSearch?search=${inputValue}`, data)
      .then((response) => {
        console.log("Response:", response);

        if (
          !response.data ||
          !response.data.responseData ||
          !response.data.responseData.searchdata
        ) {
          console.log("Invalid response structure:", response);
          setIsError(true);
          setIsLoading(false);
          return;
        }

        let data = response.data.responseData.searchdata;
        console.log("Original Data:", data);

        // ✅ SHOW ERROR ONLY IF EMPTY ARRAY
        if (Array.isArray(data) && data.length === 0) {
          setIsError(true);
          setSearchUser([]);
          setSearchHashtag([]);
          setSearchComp([]);
          setSearchJob([]);
          setSearchPost([]);
          setSearchBlog([]);
          setSearchArticle([]);
          setIsLoading(false);
          return;
        }
        // Flatten nested peopleInfo / jobInfo / author / contentStats onto display fields
        setIsError(false);
        data = mapGlobalSearchList(data);

        const addUniqueItems = (list, type) =>
          list.filter((item) => item.type === type);

        setSearchUser(addUniqueItems(data, "User"));
        setSearchHashtag(addUniqueItems(data, "Hashtag"));
        setSearchComp(addUniqueItems(data, "Company"));
        setSearchJob(addUniqueItems(data, "Job"));
        setSearchPost(addUniqueItems(data, "Post"));
        setSearchBlog(addUniqueItems(data, "Blog"));
        setSearchArticle(addUniqueItems(data, "Article"));

        setIsLoading(false);
        setTotalPages(response.data.responseData.paging.totalPages);

        setOptions((prev) => {
          const postSet = new Set(prev.map((post) => post.id));
          const uniqueNewPosts = data.filter((post) => !postSet.has(post.id));
          return [...prev, ...uniqueNewPosts];
        });

      })
      .catch((error) => {
        console.log("Error:", error);
        // setIsLoading(false);
      });
  };

  useEffect(() => {
    const controller = new AbortController();
    const delayDebounce = setTimeout(() => {
      if (inputValue && inputValue.trim().length >= 3) {
        addOptions(inputValue, controller.signal);
      } else {
        setOptions([]);
        setSearchUser([]);
        setSearchHashtag([]);
        setSearchComp([]);
        setSearchJob([]);
        setSearchPost([]);
        setSearchBlog([]);
        setSearchArticle([]);
      }
    }, 1000);

    return () => {
      clearTimeout(delayDebounce);
      controller.abort(); // cancel the API call if component updates/unmounts
    };
  }, [inputValue, page]);

  // useEffect(() => {
  //   if (inputValue) {
  //     addOptions();
  //   } else {
  //     setOptions([]);
  //     setSearchUser([]);
  //     setSearchComp([]);
  //     setSearchJob([]);
  //     setSearchPost([]);
  //   }
  // }, [inputValue, page]);

  const dropdownRef1 = useRef(null);

  const handleInfiniteScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = dropdownRef1.current;
    console.log("ScrollTop:", scrollTop);
    console.log("ClientHeight:", clientHeight);
    console.log("ScrollHeight:", scrollHeight);

    if (scrollTop + clientHeight >= scrollHeight - 1) {
      console.log("Bottom reached, increasing page");
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    if (dropdownRef1.current) {
      dropdownRef1.current.addEventListener("scroll", handleInfiniteScroll);
      return () =>
        dropdownRef1.current.removeEventListener(
          "scroll",
          handleInfiniteScroll
        );
    }
  }, [dropdownRef1]);

  const [profilPic, setProfilPic] = useState(localStorage.getItem("profilPic"));

  useEffect(() => {
    const handleProfilePicUpdate = (event) => {
      setProfilPic(event.detail);
    };

    window.addEventListener("profilePicUpdated", handleProfilePicUpdate);

    return () => {
      window.removeEventListener("profilePicUpdated", handleProfilePicUpdate);
    };
  }, []);

  const location = useLocation();
  const navigate = useNavigate();

  const submitHeaderSearch = (event) => {
    event.preventDefault();
    const query = inputValue.trim();
    if (!query) return;
    navigate(`/SearchResult?q=${encodeURIComponent(query)}`, {
      state: { searchQuery: query },
    });
    clearSearchDropdown();
  };

  const handleSearchKeyDown = (event) => {
    if (event.key === "Escape") {
      event.preventDefault();
      clearSearchDropdown();
    }
  };

  const renderHeaderSearchField = (dropdown) => (
    <form
      className={`search-container${language === "ar" ? " search-container--rtl" : ""}`}
      role="search"
      onSubmit={submitHeaderSearch}
    >
      <div className="search-icon" aria-hidden="true">
        <SearchSharpIcon className="material-symbols-sharp" />
      </div>
      <div className="search-input-container">
        <input
          type="search"
          name="q"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleSearchKeyDown}
          placeholder={t("SearchJob.HeaderPlaceholder")}
          className="search-input"
          autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
          enterKeyHint="search"
          aria-label={t("SearchJob.HeaderPlaceholder")}
        />
        {inputValue ? (
          <button
            type="button"
            className="header-search-clear"
            onClick={clearSearchDropdown}
            aria-label={t("Common.CloseSearch")}
          >
            <CloseSharpIcon className="material-symbols-sharp" />
          </button>
        ) : null}
        {dropdown}
      </div>
    </form>
  );

  const handleLogoClick = () => {
    if (location.pathname === "/NewsFeed") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const searchContainerRef = useRef(null);
  const dropdownRef = useRef(null);
  const langdropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target) &&
        !searchContainerRef.current?.contains(event.target) &&
        !event.target.closest?.(".mainheader .search-container")
      ) {
        setOptions([]);
        setInputValue("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    const clickedInsideProfileMenu =
      dropdownRef.current && dropdownRef.current.contains(event.target);
    const clickedInsideLangMenu =
      langdropdownRef.current && langdropdownRef.current.contains(event.target);

    if (!clickedInsideProfileMenu && !clickedInsideLangMenu) {
      setShowDropdown(false);
      setShowSub(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //   const base64SessionId = btoa(sessionId);

  const [encodedValue, setEncodedValue] = useState("");
  const [encodedTokenValue, setEncodedTokenValue] = useState("");

  // const handleEncode = () => {
  //   const encoded = base58.encode(Buffer.from(sessionId));

  //   setEncodedValue(encoded);
  //   const encodedToken = base58.encode(Buffer.from(token));
  //   setEncodedTokenValue(encodedToken);
  //   // console.log(encoded);
  // };

  // useEffect(() => {
  //   if (!guestModeData) {
  //     handleEncode();
  //   }
  // }, []);

  const handleEncode = () => {
    // Ensure sessionId and token are converted to strings if they are not already
    const sessionIdStr = typeof sessionId === 'string' ? sessionId : JSON.stringify(sessionId);
    const tokenStr = typeof token === 'string' ? token : JSON.stringify(token);

    const encoded = base58.encode(Buffer.from(sessionIdStr));
    setEncodedValue(encoded);

    const encodedToken = base58.encode(Buffer.from(tokenStr));
    setEncodedTokenValue(encodedToken);
  };

  useEffect(() => {
    if (!guestModeData) {
      handleEncode();
    }
  }, []);


  const handleAction = () => {
    console.log("action is working");
  };

  const [showDeleteReviewModal, setShowDeleteReviewModal] = useState(false);
  const handleCloseDeleteReviewModal = () => setShowDeleteReviewModal(false);


  // ....................Message
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (open) {
        setOpen(false); // Hide tooltip when scrolling
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [open]);

  // .............Notification
  const [openNotification, setOpenNotification] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (openNotification) {
        setOpenNotification(false); // Hide tooltip when scrolling
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [openNotification]);

  // .......................Profile
  const [openProfile, setOpenProfile] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (openProfile) {
        setOpenProfile(false); // Hide tooltip when scrolling
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [openProfile]);

  // .................................................


  // function LanguageSwitcher() {

  const changeLanguage = (lang) => {
    const code = setStoredLangCode(lang);
    i18n.changeLanguage(code);
    setCurrentLang(code);
    document.documentElement.lang = code;
    document.documentElement.dir = code === "ar" ? "rtl" : "ltr";
  };


  const normalizeSearchTitle = (value) => {
    if (value === null || value === undefined) return "";

    const rawValue = String(value);
    let parsedValue = null;

    try {
      parsedValue = JSON.parse(rawValue);
    } catch (error) {
      parsedValue = null;
    }

    if (Array.isArray(parsedValue)) {
      const tags = parsedValue
        .map((item) => item?.displayName)
        .filter(Boolean)
        .map((name) => `#${name}`);

      if (tags.length > 0) {
        return [...new Set(tags)].join(" ");
      }
    }

    let cleanedText = rawValue.replace(/\{\d*\}/g, " ");

    if (typeof DOMParser !== "undefined") {
      const parser = new DOMParser();
      cleanedText = parser.parseFromString(cleanedText, "text/html").body.textContent || cleanedText;
    } else {
      cleanedText = cleanedText.replace(/<[^>]*>/g, " ");
    }

    cleanedText = cleanedText.replace(/\s+/g, " ").trim();

    if (!cleanedText) {
      const hashtags = [...rawValue.matchAll(/\/hashtag\/([^"'/?#\s>]+)/gi)].map((match) => {
        try {
          return `#${decodeURIComponent(match[1])}`;
        } catch (error) {
          return `#${match[1]}`;
        }
      });

      if (hashtags.length > 0) {
        return [...new Set(hashtags)].join(" ");
      }
    }

    return cleanedText;
  };

  const normalizeSearchMeta = (value) => {
    if (value === null || value === undefined) return "";

    const rawValue = String(value).trim();
    if (!rawValue) return "";

    let parsedValue = null;
    try {
      parsedValue = JSON.parse(rawValue);
    } catch (error) {
      parsedValue = null;
    }

    if (Array.isArray(parsedValue)) {
      const tags = parsedValue
        .map((item) => item?.displayName)
        .filter(Boolean)
        .map((name) => `#${name}`);

      return [...new Set(tags)].join(" ");
    }

    if (parsedValue && typeof parsedValue === "object") {
      return "";
    }

    let cleanedText = rawValue.replace(/\{\d*\}/g, " ");

    if (typeof DOMParser !== "undefined") {
      const parser = new DOMParser();
      cleanedText = parser.parseFromString(cleanedText, "text/html").body.textContent || cleanedText;
    } else {
      cleanedText = cleanedText.replace(/<[^>]*>/g, " ");
    }

    return cleanedText.replace(/\s+/g, " ").trim();
  };

  const formatPostSearchItem = (item) => {
    const title = normalizeSearchTitle(item?.title);
    const additionalInfo = normalizeSearchMeta(item?.additionalInfo);
    const description = normalizeSearchMeta(item?.description);

    return {
      title,
      additionalInfo: additionalInfo && additionalInfo !== title ? additionalInfo : "",
      description:
        description && description !== title && description !== additionalInfo
          ? description
          : "",
    };
  };

  const getPostSearchLink = (item) => {
    const normalizedTitle = normalizeSearchTitle(item?.title || "");
    const isHashtagType = item?.type === "Hashtag";
    const looksLikeHashtag = normalizedTitle.startsWith("#") && !!item?.slug;

    if ((isHashtagType || looksLikeHashtag) && item?.slug) {
      return `/hashtag/${encodeURIComponent(item.slug)}`;
    }

    return `/Post/${item?.id}/${item?.slug}`;
  };

  const handleLanguageToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowSub((prev) => !prev);
  };

  const handleLanguageSelect = (event, lang) => {
    event.preventDefault();
    event.stopPropagation();
    if (normalizeLangCode(language) === lang) return;
    changeLanguage(lang);
    setShowSub(false);
    setShowDropdown(false);
    setShowDropdownRes(false);
    setTimeout(() => {
      window.location.reload();
    }, 150);
  };

  const isDark = useThemeStore((state) => state.isDark);

  const handleThemeToggle = (event) => {
    event?.stopPropagation?.();
    toggleAppTheme();
  };

  const renderThemeToggle = ({ inMenu = false } = {}) => {
    const switchControl = (
      <Toggle
        isChecked={isDark}
        handleChange={handleThemeToggle}
      />
    );

    if (!inMenu) {
      return switchControl;
    }

    return (
      <div
        className="profile-menu-toggle"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          if (event.target.closest(".toggle-container")) return;
          toggleAppTheme();
        }}
      >
        <DarkModeOutlinedIcon className="material-symbols-sharp me-2" />
        {switchControl}
      </div>
    );
  };

  const renderLanguageSwitcher = () => {
    const activeLang = normalizeLangCode(language);
    return (
      <div className="language-menu-item" ref={langdropdownRef}>
        <button
          type="button"
          className="dropdown-item language-menu-trigger"
          onClick={handleLanguageToggle}
        >
          <TranslateIcon className="material-symbols-sharp me-2" />
          <span className="dropdownTxt">
            {t("Notifications.Language")} ({activeLang})
          </span>
          <ArrowDropDownIcon
            className={`material-symbols-sharp ms-auto language-menu-caret${showSub ? " is-open" : ""}`}
          />
        </button>
        {showSub && (
          <div className="language-sub-menu">
            {SUPPORTED_LANG_CODES.map((lang) => (
              <button
                type="button"
                key={lang}
                className="dropdown-item dropdownList d-flex justify-content-between align-items-center"
                onClick={(event) => handleLanguageSelect(event, lang)}
                disabled={activeLang === lang}
                style={{
                  cursor: activeLang === lang ? "default" : "pointer",
                }}
              >
                <span>
                  {lang === "en" ? t("Common.English") : lang === "hi" ? t("Common.Hindi") : t("Common.Arabic")}
                </span>
                {activeLang === lang && <CheckIcon fontSize="small" />}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="mainheader headerLayout desktopView">
        <div className="row">
          <div className="col-md-3 left">
            <NavLink to="/NewsFeed" onClick={handleLogoClick}>
              {isDark ? (
                <div className="Logo">
                  <img src={header.whiteoglogo} alt="" />
                </div>
              ) : (
                <div className="Logo">
                  <img src={header.oglogo} alt="" />
                </div>
              )}
            </NavLink>
          </div>

          <div className="col-md-6 center ps-0" ref={searchContainerRef}>
            {renderHeaderSearchField(
                (options.length > 0 || inputValue !== "") && (
                  <ul className="suggestions-dropdown" ref={dropdownRef1}>
                     <div className="dropdown-scroll">
                    
                    <div className="notificationscroller m-1">
                      {/* {searchUser.length > 0 && (
                        <div className="suggestions-dropdown__section">
                          <p className="suggestions-dropdown__section-title">{t("Sidemenubar.People")}</p>
                        </div>
                      )}
                      {searchUser.map((item, index) => (
                        <Link to={`/User/${item?.id}`} key={index}>
                          <li
                            className="suggestion-item d-flex"
                            onClick={() => {
                              console.log("On Click Option")
                              setOptions([]);
                              setInputValue("");
                              setSearchUser([]);
                              setSearchComp([]);
                              setSearchJob([]);
                              setSearchPost([]);
                              setSearchBlog([]);
                            }}
                          >
                            <img
                              src={item?.image}
                              alt=""
                              width={30}
                              height={30}
                              className="nav-avatar"
                            />
                            <div>
                              <p className="ms-2">{normalizeSearchTitle(item?.title)}</p>
                              <p className="ms-2 f-12">{item?.additionalInfo}</p>
                              <p className="ms-2 f-12">{item?.description}</p>
                              <p className="ms-2 f-12">
                                {item?.followers} followers
                              </p>
                            </div>
                          </li>
                        </Link>
                      ))} */}
                      {isLoading ? (
                        <>
                          <div className="shimmer-cont d-flex">
                            <ShimmerDiv className="mt-2"
                              height={50} width={50} rounded={50} />
                            <div className="shimmer-header d-flex">
                              <ShimmerDiv height={50} width={"100%"} />
                            </div>
                          </div>
                          <div className="shimmer-cont d-flex">
                            <ShimmerDiv className="mt-2"
                              height={50} width={50} rounded={50} />
                            <div className="shimmer-header d-flex">
                              <ShimmerDiv height={50} width={"100%"} />
                            </div>
                          </div>
                        </>
                      ) : isError ? (
                        <div className="error-message p-3">
                          <p>{t("SearchJob.There is no search result")}</p>
                        </div>
                      ) : (
                        <>
                          {searchUser.length > 0 && (
                            <div className="suggestions-dropdown__section">
                              <p className="suggestions-dropdown__section-title">{t("Sidemenubar.People")}</p>
                            </div>
                          )}
                          {searchUser.map((item, index) => (
                            <Link to={`/User/${item?.id}/${item?.slug}`} key={index}>
                              <li
                                className="suggestion-item d-flex align-items-center"
                                onClick={() => {
                                  clearSearchDropdown();
                                }}
                              >
                                <img
                                  src={item?.image || people.DefaultProfile}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = people.DefaultProfile;
                                  }}
                                  alt=""
                                  width={30}
                                  height={30}
                                  className="nav-avatar"
                                />
                                <div>
                                  <p className="ms-2">{item?.title}</p>
                                  {item?.additionalInfo ? (
                                    <p className="ms-2 f-12">{item.additionalInfo}</p>
                                  ) : null}
                                  {item?.description ? (
                                    <p className="ms-2 f-12">{item.description}</p>
                                  ) : null}
                                {item?.followers > 0 && <p className="ms-2 f-12">{item?.followers} {item?.followers === 1 ? t("My Connection.Follower", { defaultValue: "Follower" }) : t("My Connection.Followers")}</p>}
                                </div>
                              </li>
                            </Link>
                          ))}
                        </>
                      )}

                      {searchBlog.length > 0 && (
                        <div className="suggestions-dropdown__section">
                          <p className="suggestions-dropdown__section-title">{t("Sidemenubar.Blogs")}</p>
                        </div>
                      )}
                      {searchBlog.map((item, index) => (

                        <Link
                          to={
                            "/blogs/" +
                            (item?.additionalInfo || item?.slug || item?.id || "")
                          }
                          key={index}
                        >
                          <li
                            className="suggestion-item d-flex"
                            onClick={() => {
                              clearSearchDropdown();
                            }}
                          >
                            <img
                              src={item?.image || people.DefaultProfile}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = people.DefaultProfile;
                              }}
                              alt=""
                              width={30}
                              height={30}
                              className="nav-avatar"
                            />
                            <div>
                              <p className="ms-2">{item?.title}</p>
                              {item?.category ? (
                                <p className="ms-2 f-12">{item.category}</p>
                              ) : null}
                              {item?.shortDescription ? (
                                <p className="ms-2 f-12">
                                  {item.shortDescription.length > 80
                                    ? `${item.shortDescription.slice(0, 80).trim()}...`
                                    : item.shortDescription}
                                </p>
                              ) : null}
                              <p className="ms-2 f-12">
                                {item?.createdOn || item?.description
                                  ? moment(item.createdOn || item.description).format("dddd, MMMM D, YYYY")
                                  : ""}
                              </p>
                            </div>
                          </li>
                        </Link>
                      ))}

                      {searchArticle.length > 0 && (
                        <div className="suggestions-dropdown__section">
                          <p className="suggestions-dropdown__section-title">{t("Newsfeed.Article")}</p>
                        </div>
                      )}
                      {searchArticle.map((item, index) => (
                        <Link
                          to={`/Articles/${item?.id}/${item?.slug || ""}`}
                          key={`article-${item?.id || index}`}
                        >
                          <li
                            className="suggestion-item d-flex"
                            onClick={() => {
                              clearSearchDropdown();
                            }}
                          >
                            <img
                              src={item?.image || people.DefaultProfile}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = people.DefaultProfile;
                              }}
                              alt=""
                              width={30}
                              height={30}
                              className="nav-avatar"
                            />
                            <div>
                              <p className="ms-2">{item?.title}</p>
                              {item?.author ? (
                                <p className="ms-2 f-12">{item.author}</p>
                              ) : null}
                              {item?.shortDescription ? (
                                <p className="ms-2 f-12">
                                  {item.shortDescription.length > 80
                                    ? `${item.shortDescription.slice(0, 80).trim()}...`
                                    : item.shortDescription}
                                </p>
                              ) : item?.createdOn || item?.description ? (
                                <p className="ms-2 f-12">
                                  {moment(item.createdOn || item.description).format(
                                    "dddd, MMMM D, YYYY"
                                  )}
                                </p>
                              ) : null}
                            </div>
                          </li>
                        </Link>
                      ))}

                      {searchComp.length > 0 && (
                        <div className="suggestions-dropdown__section">
                          <p className="suggestions-dropdown__section-title">
                            {t("Sidemenubar.Companies")}
                          </p>
                        </div>
                      )}
                      {searchComp.map((item, index) => (
                        <Link to={`/Company/${item?.id}/${item?.slug}`} key={index}>
                          <li
                            className="suggestion-item d-flex"
                            onClick={() => {
                              setOptions([]);
                              setInputValue("");
                            }}
                          >
                            <img
                              src={item?.image}
                              alt=""
                              width={30}
                              height={30}
                              className="nav-avatar"
                            />
                            <div>
                              <p className="ms-2">{item?.title}</p>
                              <p className="ms-2 f-12">{item?.additionalInfo}</p>
                              <p className="ms-2 f-12">{item?.description}</p>
                              {item?.followers > 0 && (
                                <p className="ms-2 f-12">
                                  {item?.followers} {t("My Connection.Followers")}
                                </p>
                              )}
                            </div>
                          </li>
                        </Link>
                      ))}

                      {searchJob.length > 0 && (
                        <div className="suggestions-dropdown__section">
                          <p className="suggestions-dropdown__section-title">{t("User Profile.Jobs")}</p>
                        </div>
                      )}
                      {searchJob.map((item, index) => (
                        <Link to={`/JobDetail/${item?.id}/${item?.slug}`} key={index}>
                          <li
                            className="suggestion-item d-flex"
                            onClick={() => {
                              clearSearchDropdown();
                            }}
                          >
                            <img
                              src={item?.image || people.DefaultProfile}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = people.DefaultProfile;
                              }}
                              alt=""
                              width={30}
                              height={30}
                              className="nav-avatar"
                            />
                            <div>
                              <p className="ms-2">{item?.title}</p>
                              {item?.companyName ? (
                                <p className="ms-2 f-12">{item.companyName}</p>
                              ) : null}
                              {item?.additionalInfo ? (
                                <p className="ms-2 f-12">{item.additionalInfo}</p>
                              ) : null}
                              {(item?.description || item?.salaryDisplay) && (
                                <p className="ms-2 f-12">
                                  {[item?.description, item?.salaryDisplay]
                                    .filter(Boolean)
                                    .join(" · ")}
                                </p>
                              )}
                            </div>
                          </li>
                        </Link>
                      ))}

                      {searchPost.length > 0 && (
                        <div className="suggestions-dropdown__section">
                          <p className="suggestions-dropdown__section-title">{t("Newsfeed.Post")}</p>
                        </div>
                      )}
                      {searchPost.map((item, index) => {
                        const formattedPost = formatPostSearchItem(item);
                        const postLink = getPostSearchLink(item);
                        const isHashtag =
                          item?.type === "Hashtag" ||
                          (normalizeSearchTitle(item?.title || "").startsWith("#") && !!item?.slug);
                        const postSnippet = item?.content || formattedPost.title || "";
                        const postAuthor = item?.author || formattedPost.additionalInfo;

                        const content = (
                          <li
                            className="suggestion-item d-flex"
                            onClick={() => {
                              clearSearchDropdown();
                            }}
                          >
                            <img
                              src={
                                item?.authorProfilePic ||
                                item?.image ||
                                people.DefaultProfile
                              }
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = people.DefaultProfile;
                              }}
                              alt=""
                              width={30}
                              height={30}
                              className="nav-avatar"
                            />
                            <div>
                              {postAuthor ? (
                                <p className="ms-2 f-12">{postAuthor}</p>
                              ) : null}
                              <p className="ms-2">
                                {postSnippet.length > 90
                                  ? `${postSnippet.slice(0, 90).trim()}...`
                                  : postSnippet}
                              </p>
                              {item?.createdOn || formattedPost.description ? (
                                <p className="ms-2 f-12">
                                  {item?.createdOn && moment(item.createdOn).isValid()
                                    ? moment(item.createdOn).format("dddd, MMMM D, YYYY")
                                    : formattedPost.description}
                                </p>
                              ) : null}
                            </div>
                          </li>
                        );

                        return isHashtag ? (
                          <a href={postLink} target="_blank" rel="noopener noreferrer" key={index}>
                            {content}
                          </a>
                        ) : (
                          <Link to={postLink} key={index}>
                            {content}
                          </Link>
                        );
                      })}
                      {searchHashtag.length > 0 && (
                        <div className="suggestions-dropdown__section">
                          <p className="suggestions-dropdown__section-title">{t("Newsfeed.Hashtag")}</p>
                        </div>
                      )}
                      {searchHashtag.map((item, index) => {
                        const formattedPost = formatPostSearchItem(item);
                        const postLink = getPostSearchLink(item);
                        const isHashtag =
                          item?.type === "Hashtag" ||
                          (normalizeSearchTitle(item?.title || "").startsWith("#") && !!item?.slug);

                        const content = (
                          <li
                            className="suggestion-item d-flex"
                            onClick={() => {
                              clearSearchDropdown();
                            }}
                          >
                            <div>
                              <p className="ms-2">{formattedPost.title}</p>
                              {formattedPost.description && (
                                <p className="ms-2 f-12">{formattedPost.description}</p>
                              )}
                            </div>
                          </li>
                        );

                        return isHashtag ? (
                          <a href={postLink} target="_blank" rel="noopener noreferrer" key={index}>
                            {content}
                          </a>
                        ) : (
                          <Link to={postLink} key={index}>
                            {content}
                          </Link>
                        );
                      })}

                    

                    </div>
                      
                     </div>
                    {(searchUser.length > 0 || searchHashtag.length > 0 || searchComp.length > 0 || searchJob.length > 0 || searchPost.length > 0 || searchBlog.length > 0 || searchArticle.length > 0) && (
                         <div className="dropdown-footer">
                             <span className="see-all p-2 ms-2 f-14">
                                <Link
                                  to="/SearchResult"
                                  state={{ searchQuery: inputValue }}
                                  className=" "
                                  onClick={() => {
                                    clearSearchDropdown();
                                  }}
                                >
                                {t("SearchJob.See all results")}
                                </Link>
                              </span> 
                         </div>
                                   
                     ) }
                  </ul>
                )
            )}
          </div>

          {/* --------------------- Guest Mode ---------------------------- */}

          <div className="col-md-3 right d-flex align-items-center justify-content-end">
            {guestModeData === "true" ? (
              // <div>
              <div className="header-action guestMode d-flex justify-content-end align-items-center">
                <Toggle
                  isChecked={isDark}
                  handleChange={handleThemeToggle}
                />

                <Dropdown className="language-dropdown me-2 SlidetoDown">
                  <Dropdown.Toggle
                    id="language-toggle"
                    variant="link"
                    className="text-decoration-none p-0 d-flex align-items-center language-btn"
                  >
                    <TranslateIcon fontSize="small" className="me-2 header-language-icon" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu align="end">
                    {["en", "hi", "ar"].map((lang) => (
                      <Dropdown.Item
                        key={lang}
                        as="button"
                        className="language-menu-item"
                        onClick={() => changeLanguage(lang)}
                      >
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <span>{lang === "en" ? t("Common.English") : lang === "hi" ? t("Common.Hindi") : t("Common.Arabic")}</span>
                          {currentLang === lang && (
                            <span className="language-menu-check">✓</span>
                          )}
                        </div>
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>

                <div className="user desktop-dropdown" ref={dropdownRef}>
                  <div
                    className="header-guest-user"
                    onClick={() => setShowDropdown(!showDropdown)}
                  >
                    <img
                      src={people.DefaultProfile}
                      width={28}
                      height={28}
                      alt=""
                      className="header-guest-avatar"
                    />
                    <div className="header-guest-text">
                      <span className="header-guest-title">
                        {t("Notifications.Guest Mode")}
                      </span>
                    </div>
                    <ArrowDropDownIcon className="header-guest-chevron" />
                  </div>
                  {showDropdown && (
                    <Dropdown.Menu show={showDropdown}>
                      <Dropdown.Item as="button" className="dropdownList">
                        <Link to="/SignIn" onClick={toggleDropdown}>
                          <PersonOutlineSharpIcon className="material-symbols-sharp me-2" />
                          <span className="dropdownTxt">{t("SignIn.Sign in")}</span>
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item as="button" className="dropdownList">
                        <Link to="/SignUp" onClick={toggleDropdown}>
                          <PersonOutlineSharpIcon className="material-symbols-sharp me-2" />
                          <span className="dropdownTxt">{t("SignIn.Sign Up")}</span>
                        </Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  )}
                </div>


              </div>
            ) : (
              // </div>
              <div className="header-action d-flex align-items-center justify-content-end Tooltip header-icon-group">
                {/* <Link to="/Notification"> */}
                <Tooltip className="Notification-Tooltip" title={t("Notifications.Notification")} arrow
                  open={openNotification}
                  onOpen={() => setOpenNotification(true)}
                  onClose={() => setOpenNotification(false)}
                  disableHoverListener
                  disableInteractive
                >

                  <div className="notification d-flex justify-content-center align-items-center"
                    // Huzaifa changes
                    onMouseEnter={() => setOpenNotification(true)}
                    onMouseLeave={() => setOpenNotification(false)}
                    onClick={() => setOpenNotification(false)}
                  // onMouseEnter={() => setOpenNotification(false)}
                  // onMouseLeave={() => setOpenNotification(false)}
                  // Huzaifa changes
                  >
                    {guestModeData !== "true" && <TopNotification
                      notifiCount={notifiCount}
                      setNotifiCount={setNotifiCount}
                      closeTooltip={() => setOpenNotification(false)}
                    />}
                  </div>
                </Tooltip>

                {/* </Link> */}
                {/* <Link to="/Message"> */}

                <Tooltip className="Messages-Tooltip" title={t("Notifications.Messages")} arrow
                  open={open}
                  onOpen={() => setOpen(true)}
                  onClose={() => setOpen(false)}
                  disableHoverListener
                  disableInteractive
                >
                  <div className="notification d-flex justify-content-center align-items-center"
                    // Huzaifa changes
                    onMouseEnter={() => setOpen(true)}
                    onMouseLeave={() => setOpen(false)}
                    onClick={() => setOpen(false)}
                  // onMouseEnter={() => setOpen(false)}
                  // onMouseLeave={() => setOpen(false)}
                  // Huzaifa changes
                  >
                    {guestModeData !== "true" && <TopMessage
                      MessagesCount={MessagesCount}
                      msgCount={msgCount}
                      setMsgCount={setMsgCount}
                      closeTooltip={() => setOpen(false)}
                    />}
                  </div>
                </Tooltip>

                {/* </Link> */}
                <Tooltip title={t("Notifications.Profile")} arrow
                      open={openProfile}
                      onOpen={() => setOpenProfile(true)}
                      onClose={() => setOpenProfile(false)}
                      // Huzaifa changes
                      disableHoverListener
                    // Huzaifa changes
                    >
                  <div className="user header-user-menu"
                    onMouseEnter={() => setOpenProfile(true)}
                    onMouseLeave={() => setOpenProfile(false)}
                  >
                    <img
                      src={profilPic}
                      width={40}
                      height={40}
                      style={{ cursor: "pointer", borderRadius: "50%" }}
                      alt=""
                      // Huzaifa changes
                      // onClick={() => setShowDropdown(!showDropdown)}
                      onClick={() => {
                        setShowDropdown(!showDropdown);
                        setOpenProfile(false);
                      }}
                    // Huzaifa changes
                    />


                    {showDropdown && (
                      <Dropdown.Menu show={showDropdown} ref={dropdownRef}
                        // Huzaifa changes
                        onMouseEnter={() => setOpenProfile(false)}
                        onMouseLeave={() => setOpenProfile(false)}
                      // Huzaifa changes
                      >
                        <Dropdown.Item as="button" className="dropdownList">
                          <Link to={`/User/${userUid}`} onClick={toggleDropdown}>
                            <PersonOutlineSharpIcon className="material-symbols-sharp me-2" />
                            <span className="dropdownTxt">{t("Notifications.Profile")}</span>
                          </Link>
                        </Dropdown.Item>

                        <Dropdown.Item as="button" className="dropdownList">
                          <Link to="/Settings/profile" onClick={toggleDropdown}>
                            <SettingsSharpIcon className="material-symbols-sharp me-2" />
                            <span className="dropdownTxt">{t("Notifications.Settings")}</span>
                          </Link>
                        </Dropdown.Item>

                        {renderLanguageSwitcher()}


                        {userRole === "Admin" ? (
                          <Dropdown.Item as="button" className="dropdownList">
                            <Link
                              to={joinUrl(ADMIN_APP_ORIGIN, `${encodedValue}/${encodedTokenValue}`)}
                              target="blank"
                              onClick={toggleDropdown}
                            >
                              <AdminPanelSettingsSharpIcon className="material-symbols-sharp me-2" />
                              <span className="dropdownTxt">{t("Notifications.Go To Admin")}</span>
                            </Link>
                          </Dropdown.Item>
                        ) : (
                          ""
                        )}

                        <Dropdown.Divider />

                        <Dropdown.Item as="button" className="dropdownList">
                          <Link
                            className="d-flex align-items-center"
                            to="/signIn"
                            onClick={async (e) => {
                              e.preventDefault();
                              const preservedLang = getStoredLangCode();
                              const sessionId = localStorage.getItem("sessionId");
                              try {
                                if (sessionId) {
                                  await axios.post("OAuth/Logout", {
                                    deviceType: "Web",
                                    sessionId,
                                    langKey: preservedLang === "en" ? "" : preservedLang,
                                  });
                                }
                              } catch (_) {
                                // Best-effort server logout.
                              }
                              disconnectRealtimeHub();
                              localStorage.clear();
                              clearAllChats();
                              sessionStorage.removeItem('hasModalShown');
                              setStoredLangCode(preservedLang);
                              window.location.href = "/signIn";
                            }}
                          >
                            <PowerSettingsNewSharpIcon className="material-symbols-sharp me-2" />
                            <span className="dropdownTxt">{t("Notifications.Logout")}</span>
                          </Link>
                        </Dropdown.Item>
                        {renderThemeToggle({ inMenu: true })}
                      </Dropdown.Menu>
                    )}
                  </div>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        {!productionWork &&
          <p className="productionWorkPara">
            {t("Common.PreproductionBanner")}</p>
        }
      </div>

      {/*------------------- Profile dropdown for Mobile view ------------------------------- */}

      <div className="mainheader align-items-center mobileView">
        <MenuSharpIcon className="material-symbols-sharp pointer" onClick={toggleMenu} />
        {renderHeaderSearchField(
            (options.length > 0 || inputValue !== "") && (
              <ul className="suggestions-dropdown" ref={dropdownRef1}>
                <div className="dropdown-scroll">
                  <div className="notificationscroller">
                {searchUser.length > 0 && (
                  <div className="suggestions-dropdown__section">
                    <p className="suggestions-dropdown__section-title">{t("Sidemenubar.People")}</p>
                  </div>
                )}
                {searchUser.map((item, index) => (
                  <Link to={`/User/${item?.id}/${item?.slug}`} key={index}>
                    <li
                      className="suggestion-item d-flex"
                      onClick={() => {
                        clearSearchDropdown();
                      }}
                    >
                      <img
                        src={item?.image || people.DefaultProfile}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = people.DefaultProfile;
                        }}
                        alt=""
                        width={30}
                        height={30}
                        className="nav-avatar"
                      />
                      <div>
                        <p className="ms-2">{item?.title}</p>
                        {item?.additionalInfo ? (
                          <p className="ms-2 f-12">{item.additionalInfo}</p>
                        ) : null}
                        {item?.description ? (
                          <p className="ms-2 f-12">{item.description}</p>
                        ) : null}
                       {item?.followers > 0 && <p className="ms-2 f-12">{item?.followers} {t("My Connection.Followers")}</p>}
                      </div>
                    </li>
                  </Link>
                ))}
                {searchComp.length > 0 && (
                  <div className="suggestions-dropdown__section">
                    <p className="suggestions-dropdown__section-title">{t("Sidemenubar.Companies")}</p>
                  </div>
                )}
                {searchComp.map((item, index) => (
                  <Link to={`/Company/${item?.id}/${item?.slug}`} key={index}>
                    <li
                      className="suggestion-item d-flex"
                      onClick={() => {
                        clearSearchDropdown();
                      }}
                    >
                      <img
                        src={item?.image || people.DefaultProfile}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = people.DefaultProfile;
                        }}
                        alt=""
                        width={30}
                        height={30}
                        className="nav-avatar"
                      />
                      <div>
                        <p className="ms-2">{item?.title}</p>
                        <p className="ms-2 f-12">{item?.additionalInfo}</p>
                        <p className="ms-2 f-12">{item?.description}</p>
                       {item?.followers > 0 && <p className="ms-2 f-12">{item?.followers} {t("My Connection.Followers")}</p>}
                      </div>
                    </li>
                  </Link>
                ))}
                {searchJob.length > 0 && (
                  <div className="suggestions-dropdown__section">
                    <p className="suggestions-dropdown__section-title">{t("User Profile.Jobs")}</p>
                  </div>
                )}
                {searchJob.map((item, index) => (
                  <Link to={`/JobDetail/${item?.id}/${item?.slug}`} key={index}>
                    <li
                      className="suggestion-item d-flex"
                      onClick={() => {
                        clearSearchDropdown();
                      }}
                    >
                      <img
                        src={item?.image || people.DefaultProfile}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = people.DefaultProfile;
                        }}
                        alt=""
                        width={30}
                        height={30}
                        className="nav-avatar"
                      />
                      <div>
                        <p className="ms-2">{item?.title}</p>
                        {item?.companyName ? (
                          <p className="ms-2 f-12">{item.companyName}</p>
                        ) : null}
                        {item?.additionalInfo ? (
                          <p className="ms-2 f-12">{item.additionalInfo}</p>
                        ) : null}
                        {(item?.description || item?.salaryDisplay) && (
                          <p className="ms-2 f-12">
                            {[item?.description, item?.salaryDisplay]
                              .filter(Boolean)
                              .join(" · ")}
                          </p>
                        )}
                      </div>
                    </li>
                  </Link>
                ))}
                {searchArticle.length > 0 && (
                  <div className="suggestions-dropdown__section">
                    <p className="suggestions-dropdown__section-title">{t("Newsfeed.Article")}</p>
                  </div>
                )}
                {searchArticle.map((item, index) => (
                  <Link
                    to={`/Articles/${item?.id}/${item?.slug || ""}`}
                    key={`m-article-${item?.id || index}`}
                  >
                    <li
                      className="suggestion-item d-flex"
                      onClick={() => {
                        clearSearchDropdown();
                      }}
                    >
                      <img
                        src={item?.image || people.DefaultProfile}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = people.DefaultProfile;
                        }}
                        alt=""
                        width={30}
                        height={30}
                        className="nav-avatar"
                      />
                      <div>
                        <p className="ms-2">{item?.title}</p>
                        {item?.author ? (
                          <p className="ms-2 f-12">{item.author}</p>
                        ) : null}
                      </div>
                    </li>
                  </Link>
                ))}
                {searchBlog.length > 0 && (
                  <div className="suggestions-dropdown__section">
                    <p className="suggestions-dropdown__section-title">{t("Sidemenubar.Blogs")}</p>
                  </div>
                )}
                {searchBlog.map((item, index) => (
                  <Link
                    to={
                      "/blogs/" +
                      (item?.additionalInfo || item?.slug || item?.id || "")
                    }
                    key={`m-blog-${item?.id || index}`}
                  >
                    <li
                      className="suggestion-item d-flex"
                      onClick={() => {
                        clearSearchDropdown();
                      }}
                    >
                      <img
                        src={item?.image || people.DefaultProfile}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = people.DefaultProfile;
                        }}
                        alt=""
                        width={30}
                        height={30}
                        className="nav-avatar"
                      />
                      <div>
                        <p className="ms-2">{item?.title}</p>
                        {item?.category ? (
                          <p className="ms-2 f-12">{item.category}</p>
                        ) : null}
                      </div>
                    </li>
                  </Link>
                ))}
                {searchPost.length > 0 && (
                  <div className="suggestions-dropdown__section">
                    <p className="suggestions-dropdown__section-title">{t("Newsfeed.Post")}</p>
                  </div>
                )}
                {searchPost.map((item, index) => {
                  const formattedPost = formatPostSearchItem(item);
                  const postLink = getPostSearchLink(item);
                  const isHashtag =
                    item?.type === "Hashtag" ||
                    (normalizeSearchTitle(item?.title || "").startsWith("#") && !!item?.slug);
                  const postSnippet = item?.content || formattedPost.title || "";
                  const postAuthor = item?.author || formattedPost.additionalInfo;

                  const content = (
                    <li
                      className="suggestion-item d-flex"
                      onClick={() => {
                        clearSearchDropdown();
                      }}
                    >
                      <img
                        src={
                          item?.authorProfilePic ||
                          item?.image ||
                          people.DefaultProfile
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = people.DefaultProfile;
                        }}
                        alt=""
                        width={30}
                        height={30}
                        className="nav-avatar"
                      />
                      <div>
                        {postAuthor ? (
                          <p className="ms-2 f-12">{postAuthor}</p>
                        ) : null}
                        <p className="ms-2">
                          {postSnippet.length > 90
                            ? `${postSnippet.slice(0, 90).trim()}...`
                            : postSnippet}
                        </p>
                      </div>
                    </li>
                  );

                  return isHashtag ? (
                    <a href={postLink} target="_blank" rel="noopener noreferrer" key={index}>
                      {content}
                    </a>
                  ) : (
                    <Link to={postLink} key={index}>
                      {content}
                    </Link>
                  );
                })}
                  </div>
                </div>
                {(searchUser.length > 0 || searchHashtag.length > 0 || searchComp.length > 0 || searchJob.length > 0 || searchPost.length > 0 || searchBlog.length > 0 || searchArticle.length > 0) && (
                  <div className="dropdown-footer">
                    <span className="see-all p-2 ms-2 f-14">
                      <Link
                        to="/SearchResult"
                        state={{ searchQuery: inputValue }}
                        className=" "
                        onClick={() => {
                          clearSearchDropdown();
                        }}
                      >
                        {t("SearchJob.See all results")}
                      </Link>
                    </span>
                  </div>
                )}
              </ul>
            )
        )}
        {guestModeData === "true" ? (
          <div className="header-action d-flex justify-content-between align-items-center">
            {/* <Tooltip title="Notification" arrow
            open={openNotification}
            onOpen={() => setOpenNotification(true)}
            onClose={() => setOpenNotification(false)}> */}

            <div className="notification d-flex justify-content-center align-items-center HideOnMobileDevice"
              onMouseEnter={() => setOpenNotification(true)}
              onMouseLeave={() => setOpenNotification(false)}>
              {guestModeData !== "true" && <TopNotification
                notifiCount={notifiCount}
                setNotifiCount={setNotifiCount} />}
            </div>
            {/* </Tooltip> */}

            {/* <Tooltip title="Messages" arrow
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}> */}
            <div className="notification d-flex justify-content-center align-items-center HideOnMobileDevice"
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}>
              {guestModeData !== "true" && <TopMessage
                MessagesCount={MessagesCount}
                msgCount={msgCount}
                setMsgCount={setMsgCount}
              />}
            </div>
            {/* </Tooltip> */}

            <div className="user ">
              <div
                className="header-guest-user header-guest-user-mobile"
                onClick={() => setShowDropdownRes(!showDropdownRes)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    setShowDropdownRes((prev) => !prev);
                  }
                }}
                role="button"
                tabIndex={0}
                aria-haspopup="menu"
                aria-expanded={showDropdownRes}
                aria-label={`${t("SignIn.Sign in")} / ${t("SignIn.Sign Up")}`}
              >
                <img
                  src={people.DefaultProfile}
                  width={32}
                  height={32}
                  alt=""
                  className="header-guest-avatar"
                />
              </div>
              {showDropdownRes && (
                <Dropdown.Menu show={showDropdownRes}>
                  <Dropdown.Item as="button" className="dropdownList">
                    <Link to="/SignIn" onClick={toggleDropdownRes}>
                      <PersonOutlineSharpIcon className="material-symbols-sharp me-2" />
                      <span className="dropdownTxt">{t("SignIn.Sign in")}</span>
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Item as="button" className="dropdownList">
                    <Link to="/SignUp" onClick={toggleDropdownRes}>
                      <PersonOutlineSharpIcon className="material-symbols-sharp me-2" />
                      <span className="dropdownTxt">{t("SignIn.Sign Up")}</span>
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  {renderLanguageSwitcher()}

                  {userRole === "Admin" ? (
                    <Dropdown.Item as="button" className="dropdownList">
                      <Link
                        to={joinUrl(ADMIN_APP_ORIGIN, `${encodedValue}/${encodedTokenValue}`)}
                        target="blank"
                        onClick={toggleDropdownRes}
                      >
                        <AdminPanelSettingsSharpIcon className="material-symbols-sharp me-2" />
                        <span className="dropdownTxt">{t("Notifications.Go To Admin")}</span>
                      </Link>
                    </Dropdown.Item>
                  ) : (
                    ""
                  )}

                  <Dropdown.Divider />

                  {renderThemeToggle({ inMenu: true })}
                </Dropdown.Menu>
              )}
            </div>
          </div>
        ) : (
          <div className="header-action d-flex justify-content-between align-items-center">
            <div className="user ">
              <img
                src={profilPic}
                width={40}
                height={40}
                style={{ cursor: "pointer", borderRadius: "50%" }}
                alt=""
                onClick={() => setShowDropdownRes(!showDropdownRes)}
              />
              {showDropdownRes && (
                <Dropdown.Menu show={showDropdownRes}>
                  <Dropdown.Item className="dropdownList">
                    <Link to={`/User/${userUid}`} onClick={toggleDropdownRes}>
                      <PersonOutlineSharpIcon className="material-symbols-sharp me-2" />
                      <span className="dropdownTxt">{t("Notifications.Profile")}</span>
                    </Link>
                  </Dropdown.Item>

                  <Dropdown.Item as="button" className="dropdownList">
                    <Link to="/Settings/profile" onClick={toggleDropdownRes}>
                      <SettingsSharpIcon className="material-symbols-sharp me-2" />
                      <span className="dropdownTxt">{t("Notifications.Settings")}</span>
                    </Link>
                  </Dropdown.Item>
                  {/* <Dropdown.Item as="div" style={{ cursor: "pointer" }}
                  onClick={() => setShowSub(!showSub)}
                >
                  <TranslateIcon className="material-symbols-sharp me-2" />
                  {t("Notifications.Language")}
                  <ArrowDropDownIcon className="material-symbols-sharp ms-3" />
 
                    {showSub && (
                    <Dropdown.Menu show={showSub}
                      className="sub-menu"
                    >
                      <Dropdown.Item as="button" className="dropdownList"
                        onClick={() => changeLanguage("en")} >{t("Common.English")}</Dropdown.Item>
                      <Dropdown.Item as="button" className="dropdownList"
                        onClick={() => changeLanguage("hi")} >{t("Common.Hindi")}</Dropdown.Item>
                      <Dropdown.Item as="button" className="dropdownList"
                        onClick={() => changeLanguage("ar")} >{t("Common.Arabic")}</Dropdown.Item>
                    </Dropdown.Menu>
                  )}
                </Dropdown.Item> */}
                  {renderLanguageSwitcher()}

                  {userRole === "Admin" ? (
                    <Dropdown.Item as="button" className="dropdownList">
                      <Link
                        to={joinUrl(ADMIN_APP_ORIGIN, `${encodedValue}/${encodedTokenValue}`)}
                        target="blank"
                        onClick={toggleDropdownRes}
                      >
                        <AdminPanelSettingsSharpIcon className="material-symbols-sharp me-2" />
                        <span className="dropdownTxt">{t("Notifications.Go To Admin")}</span>
                      </Link>
                     </Dropdown.Item>
                    ) : (
                      ""
                    )}

                  <Dropdown.Divider />

                  <Dropdown.Item as="button" className="dropdownList">
                    <Link
                      className="d-flex align-items-center"
                      to="/signIn"
                      onClick={async (e) => {
                        e.preventDefault();
                        const preservedLang = getStoredLangCode();
                        const sessionId = localStorage.getItem("sessionId");
                        try {
                          if (sessionId) {
                            await axios.post("OAuth/Logout", {
                              deviceType: "Web",
                              sessionId,
                              langKey: preservedLang === "en" ? "" : preservedLang,
                            });
                          }
                        } catch (_) {
                          // Best-effort server logout.
                        }
                        disconnectRealtimeHub();
                        localStorage.clear();
                        clearAllChats();
                        sessionStorage.removeItem('hasModalShown');
                        setStoredLangCode(preservedLang);
                        window.location.href = "/signIn";
                      }}
                    >
                      <span className="dropdownTxt">{t("Notifications.Logout")}</span>
                    </Link>
                  </Dropdown.Item>

                  {renderThemeToggle({ inMenu: true })}
                </Dropdown.Menu>
              )}
            </div>
          </div>
        )}
      </div>

      {isMobile && mobileHeaderPanel && (
        <button
          type="button"
          className="wlj-mobile-header-panel-backdrop"
          aria-label={t("Common.ClosePanel")}
          onClick={() => setMobileHeaderPanel(null)}
        />
      )}

      {isOpen && (
        <>
          <div
            className="mobile-menu-backdrop"
            onClick={toggleMenu}
            aria-hidden="true"
          />
          <LeftNavigation
            isOpen={isOpen}
            toggleMenu={toggleMenu}
            setIsOpen={setIsOpen}
            openModal={openModal}
          />
        </>
      )}
      {showModal && (
        <CreateCompany
          openModal={openModal}
          showModal={showModal}
          closeModal={closeModal}
          getCompanyList={''}
        />
      )}
    </>
  );
};

export default Header;
